var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect2, _rect3, _rect4, _path14, _path15, _path16, _rect5, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320,
    height: 480,
    viewBox: "0 0 320 480",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 480,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201 348.5V370.5",
    stroke: "#5B5B5B",
    strokeWidth: 1.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M231 348.5V370.5",
    stroke: "#5B5B5B",
    strokeWidth: 1.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M262 348.5V370.5",
    stroke: "#5B5B5B",
    strokeWidth: 1.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.5 377.5H183V290.5H240.5V211.5H285.5V377.5H320",
    stroke: "#5B5B5B",
    strokeWidth: 1.7
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M278 465.5H286.5",
    stroke: "#5B5B5B",
    strokeWidth: 1.7
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M185 465.5H272",
    stroke: "#5B5B5B",
    strokeWidth: 1.7
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M137.758 168.882C137.758 168.882 155.338 173.054 149.135 201.434L138.606 193.145",
    fill: "url(#paint0_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M105.908 168.736C105.908 168.736 88.418 173.965 95.8311 202.06L106.517 192.978",
    fill: "url(#paint1_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.758 168.882C137.758 168.882 155.338 173.054 149.135 201.434L138.606 193.145",
    stroke: "#5B5B5B",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M121.121 129C120.481 129.369 119.974 129.661 119.382 130.043C110.634 135.752 105.845 145.933 106.04 156.406L106.29 169.821L106.728 193.089L122.542 193.04L138.363 193.166L137.904 168.687L137.66 155.996C137.605 151.22 136.447 146.522 134.276 142.269C132.104 138.015 128.978 134.321 125.143 131.476C123.981 130.627 121.304 129 121.304 129H121.121Z",
    fill: "white",
    stroke: "#5B5B5B",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.908 168.736C105.908 168.736 88.418 173.965 95.8311 202.06L106.517 192.978",
    stroke: "#5B5B5B",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M127.317 165.619C131.525 162.479 132.379 156.507 129.226 152.281C126.072 148.055 120.105 147.174 115.897 150.314C111.689 153.454 110.834 159.425 113.988 163.652C117.142 167.878 123.109 168.759 127.317 165.619Z",
    fill: "#E5E4E4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M127.317 162.619C131.525 159.479 132.379 153.507 129.226 149.281C126.072 145.055 120.105 144.174 115.897 147.314C111.689 150.454 110.834 156.425 113.988 160.652C117.142 164.878 123.109 165.759 127.317 162.619Z",
    fill: "#FFFBF6",
    stroke: "#5B5B5B",
    strokeWidth: 1.7,
    strokeMiterlimit: 10
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 110.845,
    y: 193.828,
    width: 21.2486,
    height: 3.86329,
    fill: "#C4C4C4",
    stroke: "#5B5B5B",
    strokeWidth: 1.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 127,
    y: 184,
    width: 5,
    height: 4,
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 184,
    width: 2,
    height: 4,
    fill: "#C4C4C4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M118 198L108.239 419.727H103.632C90.0897 419.727 79.1951 430.884 79.4875 444.423V444.423C79.4944 444.742 79.2422 445.006 78.9236 445.014V445.014C69.5098 445.248 62 452.946 62 462.363V466",
    stroke: "#5B5B5B",
    strokeWidth: 1.7
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M126 199L138.5 435.026H154.026C171.132 435.026 185 448.893 185 466V466",
    stroke: "#5B5B5B",
    strokeWidth: 1.7
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M113 292H24V436.5H0",
    stroke: "#5B5B5B",
    strokeWidth: 1.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 166.85,
    y: 258.85,
    width: 92.3,
    height: 65.3,
    fill: "white",
    stroke: "#5B5B5B",
    strokeWidth: 1.7
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M231 302.005V281.995L213.51 272L196 281.995V302.005L213.51 312L231 302.005Z",
    stroke: "#5B5B5B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M42 383V412.5H61.5V383H42Z",
    stroke: "#5B5B5B",
    strokeWidth: 1.7
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42 323V352.5H61.5V323H42Z",
    stroke: "#5B5B5B",
    strokeWidth: 1.7
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M216.929 268.187C212.417 267.608 207.835 268.38 203.761 270.405C199.688 272.43 196.306 275.617 194.045 279.564C191.783 283.511 190.742 288.04 191.054 292.578C191.366 297.117 193.017 301.461 195.798 305.061C198.579 308.661 202.366 311.355 206.678 312.803C210.99 314.252 215.635 314.388 220.026 313.197C224.416 312.005 228.354 309.538 231.342 306.108C234.33 302.678 236.234 298.439 236.813 293.927C237.589 287.877 235.93 281.766 232.202 276.939C228.473 272.112 222.979 268.964 216.929 268.187V268.187Z",
    fill: "#FF6C37"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M207.629 292.454C207.637 292.472 207.652 292.486 207.671 292.495C207.689 292.503 207.71 292.505 207.73 292.5L211.41 291.706L209.862 290.137L207.656 292.343C207.639 292.355 207.626 292.373 207.621 292.393C207.616 292.413 207.619 292.435 207.629 292.454Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M224.86 276.653C224.347 276.653 223.841 276.769 223.379 276.991C222.916 277.213 222.51 277.536 222.189 277.936C221.868 278.336 221.641 278.803 221.524 279.302C221.407 279.801 221.404 280.321 221.515 280.821C221.625 281.322 221.847 281.792 222.163 282.196C222.479 282.599 222.882 282.927 223.341 283.155C223.801 283.382 224.306 283.504 224.818 283.511C225.331 283.518 225.839 283.409 226.304 283.194L223.972 280.862C223.945 280.835 223.924 280.803 223.91 280.768C223.895 280.733 223.888 280.696 223.888 280.658C223.888 280.62 223.895 280.583 223.91 280.548C223.924 280.513 223.945 280.481 223.972 280.455L227.02 277.409C226.408 276.917 225.645 276.65 224.86 276.653V276.653Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M227.438 277.805L224.582 280.65L226.822 282.89C226.987 282.774 227.141 282.643 227.282 282.499C227.896 281.881 228.253 281.054 228.282 280.183C228.311 279.312 228.01 278.463 227.438 277.805V277.805Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M221.723 283.056H221.672C221.613 283.055 221.554 283.061 221.495 283.072H221.474C221.41 283.086 221.347 283.104 221.286 283.127L221.238 283.15C221.191 283.169 221.147 283.193 221.104 283.219L221.054 283.251C220.998 283.29 220.946 283.333 220.897 283.38L212.426 291.853L213.475 292.902L222.445 285.029C222.496 284.985 222.542 284.935 222.583 284.882L222.622 284.831C222.653 284.787 222.68 284.74 222.705 284.691C222.719 284.664 222.73 284.636 222.742 284.608C222.757 284.572 222.77 284.534 222.781 284.496C222.781 284.468 222.797 284.44 222.804 284.413C222.815 284.356 222.823 284.298 222.827 284.24V284.164C222.827 284.123 222.827 284.082 222.827 284.04C222.827 283.999 222.827 283.985 222.815 283.957C222.773 283.74 222.667 283.541 222.511 283.384C222.355 283.227 222.156 283.12 221.939 283.077H221.895C221.838 283.066 221.781 283.059 221.723 283.056Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M210.257 289.73L211.996 291.46L220.49 282.966C220.766 282.696 221.127 282.528 221.511 282.49C220.009 281.34 218.372 281.641 210.257 289.73Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M222.923 285.36L222.82 285.462L213.85 293.332L215.375 294.855C219.156 291.278 222.511 287.872 222.923 285.36Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M200.549 303.8C200.554 303.816 200.563 303.83 200.576 303.841C200.589 303.852 200.606 303.858 200.622 303.859L204.532 304.128L202.341 301.937L200.567 303.708C200.556 303.72 200.548 303.735 200.545 303.751C200.541 303.767 200.543 303.784 200.549 303.8V303.8Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M202.75 301.529L205.061 303.841C205.089 303.87 205.126 303.889 205.165 303.895C205.205 303.9 205.246 303.892 205.28 303.871C205.316 303.853 205.344 303.823 205.361 303.787C205.377 303.75 205.38 303.709 205.37 303.671L204.981 302.01C204.956 301.902 204.967 301.789 205.014 301.689C205.06 301.589 205.138 301.507 205.236 301.456C209.289 299.425 212.557 297.334 214.956 295.246L213.346 293.636L209.896 294.379L202.75 301.529Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M212.851 293.148L211.987 292.283L210.791 293.477C210.782 293.487 210.777 293.501 210.777 293.514C210.777 293.527 210.782 293.54 210.791 293.551C210.796 293.563 210.806 293.573 210.818 293.578C210.831 293.584 210.845 293.585 210.857 293.581L212.851 293.148Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M227.519 279.659C227.507 279.623 227.487 279.589 227.462 279.561C227.436 279.533 227.405 279.511 227.37 279.496C227.335 279.481 227.297 279.474 227.259 279.475C227.221 279.476 227.183 279.485 227.149 279.501C227.115 279.518 227.084 279.541 227.06 279.571C227.036 279.6 227.018 279.634 227.008 279.671C226.998 279.708 226.996 279.746 227.002 279.784C227.008 279.821 227.022 279.857 227.043 279.889C227.111 280.027 227.138 280.182 227.121 280.336C227.103 280.489 227.042 280.634 226.944 280.754C226.911 280.792 226.891 280.84 226.884 280.89C226.878 280.94 226.886 280.991 226.908 281.037C226.929 281.083 226.963 281.121 227.006 281.149C227.048 281.176 227.098 281.19 227.148 281.191C227.187 281.19 227.226 281.181 227.261 281.165C227.297 281.148 227.328 281.124 227.353 281.094C227.516 280.896 227.618 280.655 227.647 280.401C227.677 280.146 227.632 279.889 227.519 279.659V279.659Z",
    fill: "#FF6C37"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M194 183L187 185.28L194 187.56L196.28 194.56L198.57 187.56L205.57 185.28L198.57 183L196.28 176L194 183Z",
    fill: "white",
    stroke: "#5B5B5B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9998 93L36.9998 95.28L43.9998 97.56L46.2798 104.56L48.5698 97.56L55.5698 95.28L48.5698 93L46.2798 86L43.9998 93Z",
    fill: "white",
    stroke: "#5B5B5B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M161.146 28.1487L157 29.5L161.146 30.8513L162.497 35L163.854 30.8513L168 29.5L163.854 28.1487L162.497 24L161.146 28.1487Z",
    fill: "white",
    stroke: "#5B5B5B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 144.109,
    y1: 168.882,
    x2: 144.109,
    y2: 201.434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2A528"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 100.259,
    y1: 168.736,
    x2: 100.259,
    y2: 202.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2A528"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.a3f7c1d1246d676e8c5599d6334d9e38.svg";
export { ForwardRef as ReactComponent };